export default {
      id: "ic_success_page_share-usage",
      viewBox: "0 0 18 18",
      url: "/" + "images/icons.3.109.2.svg#ic_success_page_share-usage",
      toString: function () {
        return this.url;
      }
    }